export default __webpack_public_path__ + "static/media/astronomy.f3a84bb7.webp";